import { Component, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Event, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { StorefrontComponent } from '@spartacus/storefront';
import { filter } from 'rxjs/internal/operators/filter';
import { StartupService } from './core/services/start-up.service';
import { Store } from '@ngrx/store';
import { AuthActions, AuthStorageService, OCC_USER_ID_CURRENT, StateWithClientAuth, UserIdService } from '@spartacus/core';
import { DateTimeProvider } from 'angular-oauth2-oidc';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../environments/environment';

import { Constants } from './core/constants/url.constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [NgIf, StorefrontComponent],
})
export class AppComponent implements OnInit {
  title = 'spartacusstore';
  showErrorPage = false;
  //showLoader: boolean = true;
  activatedRoute: any;
  enableLoader = true;
  BASE_URL:string = environment.baseUrl;
  constructor(private router: Router,
    private startUpService: StartupService,
    private titleService: Title,
    private oauthStorage:AuthStorageService,
    private dateTimeService:DateTimeProvider, private httpClient: HttpClient,
    protected store: Store<StateWithClientAuth>,
    protected userIdService: UserIdService, 
  ) {
    this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.enableLoader = true;
          break;
        }

        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.enableLoader = false;
          break;
        }
        default: {
          break;
        }
      }
    });
  }

  ngOnInit(): void {
    this.showErrorPage = this.startUpService.showErrorPage;
    if (this.showErrorPage) {
      this.router.navigate(['error']);
    } else {
      // this.router.navigate(['']);
    }
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => {
      this.enableLoader = false;
      const rt = this.getChild(this.activatedRoute);
      rt?.data.subscribe(data => {
        this.titleService.setTitle(data.pageLabel);
      });
    });
     // Logout redirects to '/logout' and (when ASM is disabled) does a full page reload,
     // which re-runs ngOnInit. Skip re-verifying right after such a reload to avoid an
     // endless verify-error -> logout -> reload loop.
     if (this.hasAuthErrorRedirectFlag()) {
      this.clearAuthErrorRedirectFlag();
     } else {
      this.startUpService.verifyToken().subscribe({
        next: (resp: any) => {
          if(resp && resp.statusCode === '200') {
            this.loginUserWithCookie();
          }else{
            this.router.navigate(['logout']);
          }
          console.log(resp);
        },
        error: (err: any) => {
          this.setAuthErrorRedirectFlag();
          this.router.navigate(['/logout']);
        }
      });
     }

  }
  // Short-lived cookie (survives the logout guard's localStorage/sessionStorage clear + reload)
  private readonly authErrorRedirectCookie = 'auth_error_redirect';

  private hasAuthErrorRedirectFlag(): boolean {
    return document.cookie.split('; ').some(c => c.startsWith(`${this.authErrorRedirectCookie}=`));
  }

  private setAuthErrorRedirectFlag(): void {
    document.cookie = `${this.authErrorRedirectCookie}=1; max-age=30; path=/`;
  }

  private clearAuthErrorRedirectFlag(): void {
    document.cookie = `${this.authErrorRedirectCookie}=; max-age=0; path=/`;
  }
  // tslint:disable-next-line:typedef
  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute?.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }

  }
  loginUserWithCookie(){
  this.some();

  }
  some(cdcToken?: any) {
    let emailid = localStorage.getItem('email') ?? 'some';
    let params = new HttpParams({})
      .set('grant_type', 'custom')
      .set('client_id', 'mobile_android')
      .set('username', emailid)
      .set('cdcToken', cdcToken)
      let headers = new HttpHeaders();
      headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
      this.httpClient.post(this.BASE_URL + Constants.ONLYTOKEN, params, { headers }).subscribe((response: any) => {
        if (response) {
        this.storeAccessTokenResponse(response.access_token, response.refresh_token, response.expires_in, response.scope, null)
        this.decodeToken(response.access_token);
        this.userIdService.setUserId(OCC_USER_ID_CURRENT);
        this.store.dispatch(new AuthActions.Login());
        this.router.navigate(['/']);
        }})
  }
  storeAccessTokenResponse(accessToken: string, refreshToken: string, expiresIn: number, grantedScopes: string[] | string, customParameters: any) {
    this.oauthStorage.setItem('access_token', accessToken);
    if (grantedScopes && !Array.isArray(grantedScopes)) {
      this.oauthStorage.setItem('granted_scopes', JSON.stringify(grantedScopes.split(' ')));
    }
    else if (grantedScopes && Array.isArray(grantedScopes)) {
      this.oauthStorage.setItem('granted_scopes', JSON.stringify(grantedScopes));
    }
    this.oauthStorage.setItem('access_token_stored_at', '' + this.dateTimeService.now());
    if (expiresIn) {
      const expiresInMilliSeconds = expiresIn * 1000;
      const now = this.dateTimeService.new();
      const expiresAt = now.getTime() + expiresInMilliSeconds;
      this.oauthStorage.setItem('expires_at', '' + expiresAt);
    }
    if (refreshToken) {
      this.oauthStorage.setItem('refresh_token', refreshToken);
    }
    if (customParameters) {
      customParameters.forEach((value: any, key: string) => {
        this.oauthStorage.setItem(key, value);
      });
    }
  }
  private decodeToken(token: string): any {
    try {
      // Split the JWT string (header.payload.signature)
      const parts = token.split('.');
      if (parts.length !== 3) {
        throw new Error('Invalid JWT format');
      }

      // Convert Base64Url to standard Base64
      const base64Url = parts[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      
      // Decode and parse the JSON string
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );

      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error('Failed to decode token:', error);
      return null;
    }
  }
}
